<template>
    <div>
        <div class="Tabs">
            <div v-for="(tab, index) in tabs" :key="index" :class="[{'Tabs--active': current === tab},'Tabs__item']"
                 @click="changeTab(tab)">
                {{tab.title}}
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'tabs',

  data: () => ({
    tabs: [],
    current: null
  }),

  methods: {
    addTab (tab) {
      this.tabs.push(tab)
      if (tab.active === true) {
        this.current = tab
      }
    },
    changeTab (tab) {
      this.current = tab
      this.tabs.forEach(function (value) {
        if (value === tab) {
          value.active = true
        } else {
          value.active = false
        }
      })
    }
  }

}
</script>

<style lang="scss">
    @import "../../scss/_variables";

    .Tabs {
        display: flex;
        border-bottom: 1px solid #DDD;
        &__item {
            text-transform: uppercase;
            display: block;
            border: 1px solid #FFF;
            border-bottom: 1px solid #DDD;
            padding: 15px;
            margin-right: 15px;
            letter-spacing: 0.094em;
            font-size: 0.75em;
            text-decoration: none;
            background-color: #FFF;
            cursor: pointer;
            transition: all 0.25s ease-in-out;
            border-radius: 0;
            margin-bottom: -1px;
        }
        &--active {
            background-color: #FFF;
            border: 1px solid #DDD;
            border-bottom-color: #FFF;
            color: #000
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Tabs/tabs.vue